/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveUserRequest
 */
export interface ApproveUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ApproveUserRequest
     */
    user_type_id: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveUserRequest
     */
    facility_id: string;
}

/**
 * Check if a given object implements the ApproveUserRequest interface.
 */
export function instanceOfApproveUserRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_type_id" in value;
    isInstance = isInstance && "facility_id" in value;

    return isInstance;
}

export function ApproveUserRequestFromJSON(json: any): ApproveUserRequest {
    return ApproveUserRequestFromJSONTyped(json, false);
}

export function ApproveUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_type_id': json['user_type_id'],
        'facility_id': json['facility_id'],
    };
}

export function ApproveUserRequestToJSON(value?: ApproveUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_type_id': value.user_type_id,
        'facility_id': value.facility_id,
    };
}

